import React from 'react';
import PropTypes from 'prop-types';

export default class TextAttribute extends React.Component {

    renderInput() {
        return this.props.multiLine ? <textarea value={this.props.value} onChange={this.props.onChange} />
        : <input type="text" value={this.props.value} onChange={this.props.onChange} autoFocus={this.props.haveFocus} maxLength={this.props.maxLength} />
    }

    renderSpan() {
        return <span>{this.props.value}</span>
    }   

    render() {
        const editing = this.props.editing;
        const title = this.props.title;

        return(
            <div className={editing ? "editing" : ""}>
                {title ? <label>{title}</label>: null}
                {editing ? this.renderInput() : this.renderSpan()}
            </div>
        )
    }

}

TextAttribute.propTypes = {
    value: PropTypes.string,
    title: PropTypes.string,
    editing: PropTypes.bool,
    multiLine: PropTypes.bool,
    haveFocus: PropTypes.bool,
    maxLength: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
};

